import { Card, CardHeader, mergeClasses, Text } from "@fluentui/react-components";
import { Col } from "react-grid-system";
import useStyleUtils from "../../utilities/styles";
import IDevice from "../../models/devices/IDevice";
import styles from "./DeviceCard.module.scss";
import { useNavigate } from "react-router-dom";

const HeaderText = (props: { deviceName: string }) => {
    const style = useStyleUtils();
    const headerTextStyle = mergeClasses(style.dInlineBlock, style.w100, style.textCenter);

    return (
        <Text weight="semibold" size={400} className={headerTextStyle}>{props.deviceName}</Text>
    );
};

export default function DeviceCard(props: { device: IDevice }) {
    const { device } = props;

    const navigate = useNavigate();

    const style = useStyleUtils();
    const cardStyles = mergeClasses(styles.card, style.mb3, style.dFlex, style.justifyContentCenter);

    const handleDeviceClick = () => navigate(`/d/${device.id}`);

    return (
        <Col xs={12} md={6} lg={4}>
            <Card className={cardStyles} orientation='vertical' onClick={handleDeviceClick}>
                <CardHeader header={<HeaderText deviceName={device.name} />} className={styles.header} />
            </Card>
        </Col>
    );
}